import { Router } from "express";

import { schoolController } from "../controllers/school-controller";
import { createRateLimit } from "../middleware/auth-middleware";
import { authenticateGuest } from "../middleware/guest-middleware";

const router = Router();

// Rate limiting for guest endpoints
// More lenient than authenticated endpoints since these are public access
const guestRateLimit = createRateLimit.guest(); // Will create this rate limit type

/**
 * @route   GET /api/v1/guest/schools
 * @desc    Get all schools (name and code only)
 * @access  Guest (requires guest token)
 * @query   None
 * @returns Array of schools with name and code
 */
router.get("/schools", authenticateGuest, guestRateLimit, (req, res) =>
  schoolController.getAllSchools(req, res),
);

/**
 * @route   GET /api/v1/guest/schools/search
 * @desc    Search schools by name or code
 * @access  Guest (requires guest token)
 * @query   { query: string } - Search term (minimum 2 characters)
 * @returns Array of matching schools with name and code
 */
router.get("/schools/search", authenticateGuest, guestRateLimit, (req, res) =>
  schoolController.searchSchools(req, res),
);

/**
 * @route   GET /api/v1/guest/schools/:schoolId
 * @desc    Get school details by ID
 * @access  Guest (requires guest token)
 * @params  { schoolId: string } - School ID
 * @returns School details (basic information only)
 */
router.get(
  "/schools/:schoolId",
  authenticateGuest,
  guestRateLimit,
  (req, res) => schoolController.getSchoolById(req, res),
);

export default router;
